import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import logger from 'logger';
import { select } from 'redux-saga/effects';
import * as chimeActions from 'store/chime/chimeActions';
import * as classroomActions from 'store/classroom/classroomActions';
import * as messageActions from 'store/message/messageActions';
import * as videoActions from 'store/video/videoActions';
import { put } from 'store/utils';
import * as utilActions from 'store/utils/utilActions';
export function* muteSaga(messagePayload) {
  const key = 'muteFlowSaga';
  yield put(messageActions.initAction({ key }));
  try {
    let messageAttendeeId = messagePayload.attendeeId;
    const { attendeeId } = yield select(({ chime }) => ({
      attendeeId: chime.attendeeId,
    }));
    if (messageAttendeeId === attendeeId) {
      yield put(classroomActions.toggleMuteSelfAction({ forceMute: true }));
    } else {
      yield put(
        chimeActions.updateRosterAttributeAction({
          messageAttendeeId,
          key: 'muted',
          value: true,
        })
      );
    }
    yield put(messageActions.successAction({ key }));
  } catch (error) {
    yield put(messageActions.errorAction({ key, error }));
  }
}

// export function*

export function* muteAllSaga(muteAllActorAttendeeId) {
  const key = 'muteAllSaga';
  yield put(messageActions.initAction({ key }));
  try {
    const { audioVideo, attendeeId } = yield select(({ chime }) => ({
      audioVideo: chime.audioVideo,
      attendeeId: chime.attendeeId,
    }));
    if (muteAllActorAttendeeId !== attendeeId) {
      audioVideo.realtimeMuteLocalAudio();
    }
    yield put(messageActions.successAction({ key }));
  } catch (error) {
    yield put(messageActions.errorAction({ key, error }));
  }
}

export function* stopPresenterVideoSaga(presenterAttendeeId) {
  const key = 'stopPresenterVideoSaga';
  yield put(messageActions.initAction({ key }));
  try {
    const { attendeeId } = yield select(({ chime }) => ({
      audioVideo: chime.audioVideo,
      attendeeId: chime.attendeeId,
    }));

    if (attendeeId === presenterAttendeeId) {
      yield put(videoActions.toggleVideoAction({ forceLocalOff: true }));
    }

    yield put(messageActions.successAction({ key }));
  } catch (error) {
    yield put(messageActions.errorAction({ key, error }));
  }
}

export function* chatMessageSaga(message) {
  const key = 'chatMessageSaga';
  yield put(messageActions.initAction({ key }));
  try {
    const { popout, unreadMessages } = yield select(({ classroom, message }) => ({
      popout: classroom.popout,
      unreadMessages: message.unreadMessages,
    }));
    yield put(messageActions.putMessageAction(message));
    if (!popout.open || popout.name !== 'Group Chat') {
      logger.info('Sending Notification', { message });
      yield put(
        utilActions.setNotificationAction({
          message: `${message?.payload?.payload?.name || 'Someone'} Sent A Message`,
          type: 'info',
          icon: InfoOutlinedIcon,
          notiPopoutName: 'Group Chat',
        })
      );
      yield put(messageActions.setUnreadMessagesAction(unreadMessages + 1));
    }
    yield put(messageActions.successAction({ key }));
  } catch (error) {
    yield put(messageActions.errorAction({ key, error }));
  }
}
export function* kickPresenterSaga(kickedAttendeeId) {
  const key = 'kickPresenterSaga';
  yield put(messageActions.initAction({ key }));
  try {
    const { attendeeId } = yield select(({ chime }) => ({
      attendeeId: chime.attendeeId,
    }));
    if (attendeeId === kickedAttendeeId) {
      yield put(chimeActions.leaveRoomAction());
    }
    yield put(messageActions.successAction({ key }));
  } catch (error) {
    yield put(messageActions.errorAction({ key, error }));
  }
}
